import { registerClass } from '../SatCoreRegistry';

import {
  DISTRICT_ADMIN_PROFILE_MENU,
  GENERIC_PROFILE_MENU,
  SCHOOL_ADMIN_PROFILE_MENU,
  STUDENT_PROFILE_MENU,
  TEACHER_PROFILE_MENU,
  TOP_NAV_NAME
} from '../constants';

import topNavManager from '../managers/TopNavManager';
import userManager from '../managers/UserManager';

export default class ProfileMenuService {
  static getProfileMenuInfo = () => {
    const { activeTopNavName } = topNavManager;

    // Determine user type based on active top nav
    if (activeTopNavName === TOP_NAV_NAME.AdminTopNav) {
      return this.getAdminProfileMenuInfo();
    } else if (activeTopNavName === TOP_NAV_NAME.TeacherTopNav) {
      return this.getTeacherProfileMenuInfo();
    } else if (activeTopNavName === TOP_NAV_NAME.StudentTopNav) {
      return this.getStudentProfileMenuInfo();
    } else if (activeTopNavName === TOP_NAV_NAME.GenericTopNav) {
      return this.getGenericProfileMenuInfo();
    }

    // Fallback to user role detection
    if (userManager.activePermissionId?.includes?.('admin')) {
      return this.getAdminProfileMenuInfo();
    } else if (userManager.isTeacher) {
      return this.getTeacherProfileMenuInfo();
    } else if (userManager.isStudent) {
      return this.getStudentProfileMenuInfo();
    }

    // Final fallback to generic
    return this.getGenericProfileMenuInfo();
  }

  static getAdminProfileMenuInfo = () => {
    const {
      isDistrictAdmin,
      isDistrictAssessmentAdmin,
      isDistrictProductAdmin
    } = userManager;

    const { profileMenuDistrictAdminOrderArray, profileMenuSchoolAdminOrderArray } = topNavManager;

    const isDistrictAdminProfileMenu = isDistrictAdmin || isDistrictAssessmentAdmin || isDistrictProductAdmin;

    const PROFILE_MENU = isDistrictAdminProfileMenu ? DISTRICT_ADMIN_PROFILE_MENU : SCHOOL_ADMIN_PROFILE_MENU;

    const profileMenuOrderArray = isDistrictAdminProfileMenu ? profileMenuDistrictAdminOrderArray : profileMenuSchoolAdminOrderArray;

    return {
      PROFILE_MENU,
      profileMenuOrderArray
    };
  };

  static getTeacherProfileMenuInfo = () => {
    const { profileMenuTeacherOrderArray } = topNavManager;

    return {
      PROFILE_MENU: TEACHER_PROFILE_MENU,
      profileMenuOrderArray: profileMenuTeacherOrderArray
    };
  };

  static getStudentProfileMenuInfo = () => {
    const { profileMenuStudentOrderArray } = topNavManager;

    return {
      PROFILE_MENU: STUDENT_PROFILE_MENU,
      profileMenuOrderArray: profileMenuStudentOrderArray
    };
  }

  static getGenericProfileMenuInfo = () => {
    const { profileMenuGenericOrderArray } = topNavManager;

    return {
      PROFILE_MENU: GENERIC_PROFILE_MENU,
      profileMenuOrderArray: profileMenuGenericOrderArray
    };
  }
}

registerClass('ProfileMenuService', ProfileMenuService);
